<template>
  <div>
    <slot name="label">
      <label class="typo__label" :for="name">{{ label }}</label>
    </slot>
    <input :name="name" v-if="value && value.email && !multiple" type="hidden" :value="value.email" :class="value.email">
    <input :name="name" v-else type="hidden" :value="valueForUsers">
    <multiselect
      v-model="value"
      :name="`${name}-fake`"
      :id="name"
      :label="inputLabel"
      track-by="email"
      :placeholder="searchString"
      open-direction="bottom"
      :options="searchResults"
      :multiple="multiple"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="closeSelect"
      :options-limit="300"
      :limit="3"
      :limit-text="limitText"
      :max-height="600"
      :show-no-results="true"
      :hide-selected="false"
      selectLabel=""
      deselectLabel=""
      selectedLabel=""
      @search-change="onMultiselectSearch"
      :class="customClass"
      :disabled="isDisabled">
      <template slot="singleLabel" slot-scope="props">
        <div class="option__desc">
          <div class="option__title">{{ props.option.firstname }} {{ props.option.lastname }}</div>
          <div class="option__small">{{ props.option.email }}</div>
        </div>
      </template>
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <div class="option__title">{{ props.option.firstname }} {{ props.option.lastname }}</div>
          <div class="option__small">{{ props.option.email }}</div>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'

export default {
  components: { Multiselect },

  props: {
    name: String,
    label: String,
    searchString: String,
    selectedValue: String,
    customClass: String,
    models: String,
    multiple: {
      default: false,
      type: Boolean
    },
    inputLabel: {
      default: 'name',
      type: String,
    },
    closeSelect: {
      default: true,
      type: Boolean,
    },
    disabled: {
      default: '0',
      type: String,
    },
  },

  data () {
    return {
      value: null,
      searchResults: [],
      isLoading: false,
      search: '',
    }
  },

  mounted() {
    this.findModels(true)
  },

  computed: {
    isDisabled() {
      return this.disabled === '1' ? true : false
    },

    valueForUsers() {
      return this.value ? this.value.map((v) => v.email) : ""
    }
  },

  methods: {
    limitText (count) {
      return `et ${count} autre`
    },

    onMultiselectSearch(query) {
      this.search = encodeURIComponent(query.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))

      this.findModels()
    },

    findModels (mounted = false) {
      this.isLoading = true

      axios.get(`/webapi/${this.models}?search=${this.search}`)
        .then((response) => {
          if (response && response.data) {
            this.searchResults = response.data
          }

          if (mounted) {
            if (this.selectedValue && this.selectedValue.length) {
              const selectedVal = this.searchResults.find(d => d.email === this.selectedValue)

              if (selectedVal !== undefined) {
                this.value = selectedVal
              }
            }
          }
        })
        .catch((error) => {
          console.log(error.response)
        })
        .finally(() => this.isLoading = false)
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect__option--selected {
  color: var(--gray-dark);
  font-weight: 500;
}

.option__title {
  font-size: .9375rem;
  line-height: 1.1;
  letter-spacing: -.02em;
  margin-bottom: .1875rem;
}

.option__small {
  font-size: .8375rem;
}

.multiselect.is-invalid  {
  .multiselect__tags{
    border-color: var(--danger);
  }
}
</style>
